<script lang="ts">
  import Star from '../icons/Star.svelte';
  import { starInGameOver } from '~/animations.svelte';

  type Props = {
    stars: number;
    bonus: boolean;
  };
  const props: Props = $props();
</script>

<div class="title">
  Stars:
  {#each Array.from({ length: Math.max(props.stars, 3) }) as _, i}
    <div
      class="star-container"
      in:starInGameOver|global={{ duration: 500, delay: 250 * (i + 1) }}
    >
      <Star
        size={36}
        outlined
        class={i === props.stars - 1 && props.bonus
          ? 'green'
          : i <= props.stars - 1
            ? 'yellow'
            : 'grey'}
      />
    </div>
  {/each}
</div>

<style>
  .title {
    display: grid;
    grid-auto-flow: column;
    justify-content: center;
    height: 1.5em;
    gap: 0.25em;
  }
  .star-container {
    display: flex;
    align-items: center;
  }
</style>
